<script>
  import { onDestroy, createEventDispatcher, onMount } from 'svelte';
  import { activeView, loginStore } from './loginStore';
  import { loggedInUser, userHasAlias } from '../../Store/user-store';
  import Anonymous from './Anonymous.svelte';
  import Sumo from './Sumo.svelte';
  import SumoAlias from './SumoAlias.svelte';
  import ChooseLogin from './ChooseLogin.svelte';
  import ChatRules from './ChatRules.svelte';
  import { trackEvent } from '../../analytics';
  import { channel } from '../Chat/chat-store';

  const dispatch = createEventDispatcher();

  export let basePath = '';
  export let channelId = '';

  onDestroy(() => {
    loginStore.close();
  });

  const onSumoUserLoggedIn = async () => {
    loginStore.setActiveView(activeView.SUMO_LOGIN_ALIAS);
  };

  const onUserHasAlias = async () => {
    $userHasAlias = true;
    loginStore.setActiveView(activeView.CHAT_RULES);
  };

  const onUserConfirmedGoodBehaviour = async () => {
    if ($channel) {
      let action = $loggedInUser.isAnonymous
        ? 'Chat - Confirm guest join'
        : 'Chat - Confirm TV 2 login';
      trackEvent({
        action: action,
        label: $channel.id,
        dimensions: {
          chatName: $channel.name,
          chatCategory: $channel.category,
        },
      });
    }
    dispatch('user-is-ready');
    loginStore.close();
  };

  const onCancelLogin = async () => {
    loginStore.close();
    dispatch('did-cancel');
  };
</script>

<div class="login-container" data-category={$channel && $channel.category}>
  {#if $loginStore.activeView === activeView.HAS_NOT_JOINED}
    <button class="join-chat-btn" on:click={() => loginStore.setActiveView(activeView.JOIN_CHAT)}
      >Bli med i chatten</button
    >
  {:else if $loginStore.activeView === activeView.ANONYMOUS_LOGIN}
    <Anonymous on:user-has-alias={onUserHasAlias} {channelId} />
  {:else if $loginStore.activeView === activeView.SUMO_LOGIN}
    <Sumo on:user-logged-in={onSumoUserLoggedIn} {basePath} />
  {:else if $loginStore.activeView === activeView.SUMO_LOGIN_ALIAS}
    <SumoAlias on:user-has-alias={onUserHasAlias} on:close={onCancelLogin} />
  {:else if $loginStore.activeView === activeView.CHAT_RULES}
    <ChatRules
      on:user-confirmed-good-behaviour={onUserConfirmedGoodBehaviour}
      on:close={onCancelLogin}
    />
  {:else if $loginStore.activeView === activeView.JOIN_CHAT}
    <ChooseLogin />
  {/if}
</div>

<style src="./login.scss"></style>
